import React from "react";

const AvgRevenue = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        width="55.7828"
        height="55.7828"
        rx="27.8914"
        fill="#F29339"
      />
      <g clip-path="url(#clip0_1_9485)">
        <mask
          id="mask0_1_9485"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="16"
          y="17"
          width="25"
          height="25"
        >
          <rect x="16.0137" y="17.1819" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1_9485)">
          <path
            d="M19.4143 38.1819C18.8727 38.1819 18.4205 38.0005 18.0578 37.6378C17.695 37.275 17.5137 36.8229 17.5137 36.2813V18.1819H18.6901V36.2813C18.6901 36.4625 18.7655 36.6285 18.9163 36.7792C19.0671 36.93 19.2331 37.0054 19.4143 37.0054H37.5137V38.1819H19.4143ZM22.0837 34.0642V25.4669H24.4366V34.0642H22.0837ZM27.3778 34.0642V19.5845H29.7307V34.0642H27.3778ZM32.6719 34.0642V30.1728H35.0251V34.0642H32.6719Z"
            fill="#F29339"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1_9485">
          <rect
            width="22"
            height="22.0098"
            fill="white"
            transform="translate(16.8906 17.9556)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AvgRevenue;
